import {
    FETCH_UPDATE_COMMONS_CAPACITIES_REQUEST,
    FETCH_UPDATE_COMMONS_CAPACITIES_SUCCESS,
    FETCH_UPDATE_COMMONS_CAPACITIES_FAILURE,
    SET_UPDATE_COMMONS_CAPACITIES
} from '../../actions/commonsCapacities/update-commonsCapacities-actions';

const initialState = {
    updatedCommonsCapacities: null,
    commonsCapacities: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const UpdateCommonCapacitiesReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_UPDATE_COMMONS_CAPACITIES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case SET_UPDATE_COMMONS_CAPACITIES:
            return {
                ...state,
                isLoading: false,
                error: null,
                commonsCapacities: { ...action.payload }
            };
        case FETCH_UPDATE_COMMONS_CAPACITIES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updatedCommonCapacities: action.payload[0],
            };
        case FETCH_UPDATE_COMMONS_CAPACITIES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default UpdateCommonCapacitiesReducer;